module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xczx_result_ending_box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("感谢您的参与!")]), _vm._v(" "), _c('div', {
    staticClass: "product"
  }, [_vm._v("云南特色产品公益集市")]), _vm._v(" "), _c('div', {
    staticClass: "qcard"
  }, [_c('div', [_c('div', {
    on: {
      "click": _vm.qcord
    }
  }, [_c('img', {
    attrs: {
      "src": require("./img/dh.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', [_c('div', {
    on: {
      "click": _vm.previewImg
    }
  }, [_c('img', {
    attrs: {
      "src": require("./img/miniProgram.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('van-overlay', {
    attrs: {
      "show": _vm.showAlert
    },
    on: {
      "click": function($event) {
        _vm.showAlert = false
      }
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('img', {
    staticStyle: {
      "width": "300px",
      "height": "300px"
    },
    attrs: {
      "src": require("./img/miniProgram.jpg"),
      "alt": ""
    }
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("请直接点击上方二维码"), _c('br'), _vm._v("参与消费帮扶")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("请用微信\"扫一扫\"上方二维码"), _c('br'), _vm._v("参与消费帮扶")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-beb425ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/xczx/result.vue
// module id = 910
// module chunks = 2